module.exports = __webpack_public_path__ + "img/6.01c92dde.png";